export interface Prosody {
  rate: number;
}

export type VoiceDataType = VoiceDemoDataType['voices'][number];

export enum PLAY_STATE {
  PLAYING,
  STOPPED,
  LOADING,
  DISABLED,
}

/**
 * This interface was referenced by `Config`'s JSON-Schema
 * via the `definition` "cta-urls".
 *
 * @format
 */

export interface CtaUrl {
  id: string;
  name: string;
  url: string;
  updatedAt: string;
  createdAt: string;
}

export interface VoiceDemoDataType {
  languageName: string;
  languageCode: string;
  voices: Array<{
    region?: string;
    displayName: string;
    name: string;
    gender: 'male' | 'female' | 'not-specified';
    engine: string;
    languageCode: string;
    image: string;
    imageLarge: string;
    customText: string | undefined;
    previewAudio: string | undefined;
    description: string | undefined;
    isCelebrity: boolean | undefined;
    models: string[];
  }>;
}

export type Gender = 'male' | 'female';

type VoiceType = 'shared' | 'personal';

export interface Voice {
  id: string;
  type: VoiceType;
  display_name: string;
  models: Array<{ languages: Array<{ locale: string }>; name: string }>;
  gender: Gender | '';
  preview_audio?: string | null;
  avatar_image?: string | null;
}

export type StyleText = Record<string, Record<string, string>>;
